<template>
  <div class="init-notice">
    <div class="notice" v-if="islandscape">
      <div class="close" @click="close" v-if="noticeInfo.type_id!=='1'"></div>
      <div class="notice-con">
        <div
          :class="articleTab==0 ? 'notice-container active' : 'notice-container'"
          v-html="article.notice1"
        ></div>
        <div
          :class="articleTab==1 ? 'notice-container active' : 'notice-container'"
          v-html="article.notice2"
        ></div>
        <div
          :class="articleTab==2 ? 'notice-container active' : 'notice-container'"
          v-html="article.notice3"
        ></div>
      </div>
      <div class="notice-nav">
        <div
          :class="articleTab==key ? 'notice-nav-item active' : 'notice-nav-item'"
          @click="noticeChange(key)"
          v-bind:key="key"
          v-for="(item,key) in title"
        >{{item}}</div>
      </div>
    </div>
    <div class="portrait-notice" v-else>
      <div class="close" @click="close" v-if="noticeInfo.type_id!=='1'"></div>
      <div class="notice-container">
        <div :class="articleTab===0 ?' article active' : 'article'" v-html="article.notice1"></div>
        <div :class="articleTab===1 ?' article active' : 'article'" v-html="article.notice2"></div>
        <div :class="articleTab===2 ?' article active' : 'article'" v-html="article.notice3"></div>
      </div>
      <div class="switch-page">
        <div class="left" @click="print"></div>
        <div class="center">
          <span
            :class="articleTab===key ? 'active' :''"
            v-bind:key="key"
            v-for="(item,key) in title"
          >{{key+1}}</span>
        </div>
        <div class="right" @click="next"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import FN from "../../utility/fn.js";
export default {
  data() {
    return {
      articleTab: 0,
      title: ["我的区服我命名", "首发线下活动", "温馨提示"],
      article: '',
      noticeInfo: ""
    };
  },
  computed: {
    ...mapGetters(["screen", "islandscape"])
  },
  mounted() {
    console.log("screen", this.screen);
    this.getInitNoticeInfo();
  },
  methods: {
    noticeChange(i) {
      this.articleTab = i;
    },
    getInitNoticeInfo() {
      this.noticeInfo = FN.getSession("FUSE_INIT_INFO").init_notice
      this.article = JSON.parse(FN.getSession("FUSE_INIT_INFO").init_notice.notice_cfg)
    },
    closeNotice() {
      this.$store.dispatch("SET_SDK_COMPONENT_NOTICE", "");
    },
    print () {
      let index = this.articleTab
      if (index < 1) {
        this.articleTab = 2
      } else {
        this.articleTab = this.articleTab - 1
      }
    },
    next () {
      let index = this.articleTab
      if (index < 2) {
        this.articleTab = this.articleTab + 1
      } else {
        this.articleTab = 0
      }
    },
    close() {
      this.$store.dispatch('SET_SDK_COMPONENT_NOTICE', '')
    }
  }
};
</script>
<style lang="scss" scoped>
.init-notice {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 601;
  background: rgba(245, 245, 245, 0.5);
  .close{
    background-image:url('../../assets/img/icon-close.png');
    background-size:.54rem .54rem;
    width:.54rem;
    height: .54rem;
    position: absolute;
    right: 0;
    top: 0;
  }
  .font-notice {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -moz-box;
    -webkit-box-align: center;
    -moz-box-align: center;
    -webkit-box-pack: center;
    -moz-box-pack: center;
  }
}
.notice {
  width: 6rem;
  height: 6rem;
  margin: 0.3rem auto;
  position: relative;
  .close{
    background-image:url('../../assets/img/icon-close.png');
    background-size:.54rem .54rem;
    width:.54rem;
    height: .54rem;
    position: absolute;
    right: -.12rem;
    top: -.13rem;
  }
}
.notice .notice-nav {
  width: 100%;
  height: 1rem;
  display: flex;
  justify-content: space-between;
  z-index: 99;
  color: #333;
  .notice-nav-item {
    width: 100%;
    height: 18vh;
    font-size: 14px;
    background-color: #ff8a00;
    border-right: 1px solid #fff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    &.active {
      color: #fff;
      background-color: #a95a05;
    }
    &:last-child {
      border-right: none;
    }
  }
}
.notice .notice-con {
  width: 5.6rem;
  height: 5rem;
  background: #fefdc5;
  border: 0.2rem solid #ff8a00;
  font-size: 16px;

  .notice-container {
    display: none;
    width: 95%;
    height: 4.8rem;
    margin: 0 auto;
    overflow-y: auto;
    word-wrap: break-word;

    &.active {
      display: block;
    }
  }
  // padding:.3rem;
  //  box-sizing: border-box;
}

::-webkit-scrollbar {
  width: 10px; /*对垂直流动条有效*/
  height: 10px; /*对水平流动条有效*/
}

/*定义滚动条的轨道颜色、内阴影及圆角*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  // border:1px solid #000;
  background-color: #fefdc5;
  border-radius: 3px;
}

/*定义滑块颜色、内阴影及圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 3px;
  height: 50px;
  // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
  background-color: #ff8a00;
}

/*定义两端按钮的样式*/
::-webkit-scrollbar-button {
  background-color: #fefdc5;
}

/*定义右下角汇合处的样式*/
::-webkit-scrollbar-corner {
  background: #fefdc5;
}
.portrait-notice {
  width: 6rem;
  height:80%;
  background-color: #ff8a00;
  border: 2vh solid #ff8a00;
  box-sizing: border-box;
  position: relative;
      left: 50%;
    margin-left: -3rem;
    top: 50%;
    margin-top: -77%;
  .close{
    background-image:url('../../assets/img/icon-close.png');
    background-size:.54rem .54rem;
    width:.54rem;
    height: .54rem;
    position: absolute;
    right: -.28rem;
    top: -.28rem;
  }
  // border-radius:.2rem;
  .notice-container {
    background: #fefdc5;
    border-radius: 0.2rem;
    font-size: 26px;
    height: 100%;
    .article {
      width: 95%;
      overflow-y: auto;
      height: 80%;
      margin: 0 auto;
      display: none;
      word-wrap: break-word;
      &.active {
        display: block;
      }
    }
  }
}
.switch-page {
  width: 2.82rem;
  height: 0.67rem;
  position: absolute;
  left: 50%;
  margin-left: -1.41rem;
  bottom:1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .left {
    width: 0.35rem;
    height: 0.16rem;
    background-image: url("../../assets/img/prne.png");
    background-size: 100% 100%;
  }
  .center {
    height: 0.67rem;
    display: flex;
    align-items: center;
    span {
      width: 0.35rem;
      // .4rem
      height: 0.35rem;
      background-color: #d3d3d3;
      color: #fff;
      border-radius: 50%;
      display: inline-block;
      text-align: center;
      line-height: 0.35rem;
      margin-right: 3px;
      &.active {
        width: 0.45rem;
        height: 0.45rem;
        line-height: 0.45rem;
        background-color: #ff8a00;
      }
    }
  }
  .right {
    width: 0.35rem;
    height: 0.16rem;
    background-image: url("../../assets/img/next.png");
    background-size: 100% 100%;
  }
}

</style>
